import { render, staticRenderFns } from "./admin-ope.vue?vue&type=template&id=1ae179f8&scoped=true&"
import script from "./admin-ope.vue?vue&type=script&lang=js&"
export * from "./admin-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae179f8",
  null
  
)

export default component.exports